import { Injectable, Injector } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';

export enum ModalType {
  FullScreen = 1,
  Medium = 2,
  Small = 3,
  Half = 4,
  Large = 5
}

export interface ModalOptions {
  modalType: ModalType ;
  disableClose?: boolean;
  initialTab?: number,
  data?: any;
  // Lets the modal inject the opener's component-level providers, e.g. the quote wizard's WizardStore
  injector?: Injector;
  // Open on top of the current modal instead of closing it
  stacked?: boolean;
}


@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private _currentDialog!: MatDialogRef<any>;

  constructor(
    private dialog: MatDialog,
  ) {}

  open(component: any, modalOptions: ModalOptions, afterClosed?: (result: any) => void) {
    if (!modalOptions.stacked) {
      this.closeAll(); // we only want one modal open at a time
    }
    const modalType = modalOptions.modalType;
    const initialTab = modalOptions.initialTab;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;

  
    dialogConfig.data = {
      ...modalOptions.data,
      initialTab: initialTab
    };
    
    dialogConfig.disableClose = modalOptions.disableClose;
    dialogConfig.injector = modalOptions.injector;

    if (modalType === ModalType.FullScreen) {
      dialogConfig.panelClass = 'full-screen-modal-panel-class';
    }

    if (modalType === ModalType.Medium) {
      dialogConfig.panelClass = 'medium-modal-panel-class';
    }

    if (modalType === ModalType.Small) {
      dialogConfig.panelClass = 'small-modal-panel-class';
    }

    if (modalType === ModalType.Half) {
      dialogConfig.panelClass = 'half-modal-panel-class';
    }

    if (modalType === ModalType.Large) {
      dialogConfig.panelClass = 'large-modal-panel-class';
    }

    const previousDialog = modalOptions.stacked ? this._currentDialog : undefined;
    const dialogRef = this.dialog.open(component, dialogConfig);
    this._currentDialog = dialogRef;
    if (previousDialog) {
      // Hand close() back to the modal underneath, or its close button would target this closed one
      dialogRef
        .afterClosed()
        .pipe(take(1))
        .subscribe(() => {
          if (this._currentDialog === dialogRef) {
            this._currentDialog = previousDialog;
          }
        });
    }

    if (afterClosed) {
      this._currentDialog
        .afterClosed()
        .pipe(take(1))
        .subscribe((result: any) => {
          afterClosed(result);
        });
    }
  }

  close() {
    this._currentDialog.close();
  }

  closeAll() {
    this.dialog.closeAll();
  }


}
